import { useState } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

function truncateText(text, maxLength = 60) {
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '...';
};

const StudyPlans = ({
        studyPlans,
        onViewStudyPlan,
        onDeleteStudyPlan,
        onReorderStudyPlans,
        isArchived,
        hasSubscriptionAction = () => false
    }) => {
    const [isReorderMode, setIsReorderMode] = useState(false);
    
    const onDragEnd = async (result) => {
        if (!isReorderMode) return;
        if (!result.destination) return;
        if (result.destination.index === result.source.index) return;
      
        const items = Array.from(studyPlans);
        const [reorderedItem] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, reorderedItem);

        await onReorderStudyPlans(items);
    }

    const toggleReorderMode = () => {
        setIsReorderMode((prev) => !prev);
    };

    return studyPlans.length > 0
        ? <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId="droppableTable">
                {(provided) => (
                <table className="border border-gray-200 mt-2">
                <thead className="bg-green-700 text-white">
                    <tr>
                    <th className="font-normal p-2 text-left">Subject</th>
                    <th className="font-normal p-2 text-left">Learning goals</th>
                    <th className="font-normal p-2 text-right">
                        <button
                            type="button"
                            className={`inline-flex items-center px-1 py-1 rounded-md transition-all ${isReorderMode ? 'bg-green-600 ring-2 ring-white/70' : 'hover:bg-green-600/50'}`}
                            aria-label={isReorderMode ? 'Done reordering' : 'Reorder study plans'}
                            title={isReorderMode ? 'Done reordering' : 'Reorder study plans'}
                            onClick={toggleReorderMode}>
                            <img src="/icon-list-reorder3.png" alt="" className="w-4 h-4 brightness-0 invert" />
                        </button>
                    </th>
                    </tr>
                </thead>
                <tbody {...provided.droppableProps} ref={provided.innerRef}>
                    {
                    studyPlans.map((studyPlan, i) => (
                        <Draggable key={studyPlan.id} draggableId={String(studyPlan.id)} index={i} isDragDisabled={!isReorderMode}>
                        {(provided) => (
                        <tr 
                            {...provided.draggableProps}
                            ref={provided.innerRef}
                            style={{
                            ...provided.draggableProps.style,
                            tableLayout: 'fixed'
                            }}
                            className="border border-gray-200 bg-white">
                            <td className="p-1 pr-4 whitespace-nowrap">{studyPlan.emoji} {studyPlan.subject}</td>
                            <td className="p-1 pr-6">
                                <span className="block sm:hidden">{truncateText(studyPlan.goal)}</span>
                                <span className="hidden sm:block">{studyPlan.goal}</span>
                            </td>
                            <td className="p-1 min-w-[92px]">
                                <div className="flex justify-end items-center gap-2">
                                    {isReorderMode && (
                                        <div
                                            className="cursor-grab active:cursor-grabbing px-1 py-1 rounded hover:bg-gray-100"
                                            aria-label="Drag to reorder"
                                            title="Drag to reorder"
                                            {...provided.dragHandleProps}>
                                            <span className="text-2xl text-gray-500 px-2">≡</span>
                                        </div>
                                    )}
                                    {!isReorderMode && (
                                        <button type="button" className="text-lg leading-none hover:opacity-75"
                                            title="View study plan"
                                            aria-label="View study plan"
                                            onClick={() => onViewStudyPlan(studyPlan)}>
                                            🔎
                                        </button>
                                    )}
                                    {
                                        !isArchived && !isReorderMode && <button type="button" className="text-lg leading-none cursor-pointer hover:opacity-75"
                                        title="Archive study plan"
                                        aria-label="Archive study plan"
                                        onClick={() => onDeleteStudyPlan(studyPlan)}>
                                            🗑️
                                    </button>
                                    }
                                </div>
                            </td>
                        </tr>
                        )}
                        </Draggable>
                    ))
                    }
                    {provided.placeholder}
                </tbody>
                </table>
                )}
            </Droppable>
            </DragDropContext>
        : <></>;
};

export default StudyPlans;
